import React, { useEffect, useState } from "react";
import {ListPaymentsResponse, Payment} from "../../http/protocol";
import {formatDate} from "../../util/date";
import {getContainer} from "../../ioc/IOCSetup";
import {PaymentService} from "../../services/PaymentService";
import {Link} from "react-router-dom";

interface Props {
    params: {id: string}
}

const UserPaymentHistory: React.FC<Props> = (props: Props) => {
    const paymentService : PaymentService = getContainer().getPaymentService();
    const [userId, setUserId] = useState(props.params.id);
    const [userPaymentList, setUserPaymentList] = useState<ListPaymentsResponse>();
    
    async function getData(id:any){
        let payment: any = {userId:userId, ascending: false};
        await paymentService.list(payment)
        .then((data:ListPaymentsResponse) => {
            setUserPaymentList(data);
         })
         .catch(e=>{
           console.error("Error gettting payment list endpoint");
           setUserPaymentList({});
         }); 
    }

    useEffect(() => {
        setUserId(userId);
        getData(userId);
    },[userId]);

    const renderUserHistory = () => {
        let list = userPaymentList && userPaymentList.items;
        let lastTenTransactions : Payment[] = [];
        let rows:any;
        if(list) {
            let listMaxLength = list.length > 10 ? 10 : list.length;
            lastTenTransactions = list.slice(0,listMaxLength);
            rows = lastTenTransactions.map(p => {
                return (
                    <tr key={p.id}>
                        {p.created && (
                            <td>{formatDate(Number(p.created.toString().split(".").join("").substring(0,13)))}</td>
                        )}
                        <td>{p.type}</td>
                        <td>{p.amount}</td>
                        <td>{p.currency}</td>
                        <td>{p.status}</td>
                    </tr>
                );
            });
        }

        return (
            <table className="table table-striped mb-0 dt-responsive nowrap dataTable no-footer dtr-inline">
                <thead>
                <tr>
                    <th>Timestamp</th>
                    <th>Event Type</th>
                    <th>Amount</th>
                    <th>Currency</th>
                    <th>Payment Status</th>
                </tr>
                </thead>
                <tbody>
                {rows}
                </tbody>
            </table>
        );
    }

        return (
            <div className="col-lg-12">
                <div className={"card"}>
                    <div className="card-box">
                        <h4>Payment History</h4>
                    </div>
                    <div className="card-body">
                        <div className="ibox-content text-right">
                            <p className="text-left">Up to 10 Last:</p>
                            <div className="table-responsive">
                                {renderUserHistory()}
                            </div>
                            <Link className="btn btn-primary" to={{
                                pathname: "/payments/userId/".concat(userId),
                                state: {
                                    listRequest : {userId:userId}
                                }
                            }}>
                                <i className="fe-eye"/> View All
                            </Link>
                        </div>
                        <div className="ibox-content">
                        </div>
                    </div>
                </div>
            </div>
        )
    }

export default UserPaymentHistory;
